import { createContext, useContext } from 'react'

export const ActiveProjectContext = createContext<{
	project: Project
	tracks: Track[]
	isEditable?: boolean
	isSimilarTracks?: boolean
	onTracksDelete?: (tracksToDelete: Track[]) => Promise<boolean>
	onChangeNotes?: (notes: string, track: Track) => void
	reorderTracks?: (
		oldPosition: number,
		newPosition: number,
		type: 'Drag' | 'To Bottom' | 'To Top',
		trackId?: number
	) => void
} | null>({
	project: null,
	tracks: [],
	isEditable: false,
	isSimilarTracks: false,
})

export const useActiveProject = (): {
	project: Project
	tracks: Track[]
	isEditable?: boolean
	isSimilarTracks?: boolean
	onTracksDelete?: (tracksToDelete: Track[]) => Promise<boolean>
	onChangeNotes?: (notes: string, track: Track) => void
	reorderTracks?: (
		oldPosition: number,
		newPosition: number,
		type: 'Drag' | 'To Bottom' | 'To Top',
		trackId?: number
	) => void
} => {
	const context = useContext(ActiveProjectContext)

	return context
}
